/** Saisonplanung (ADR 0013). */
export default {
  title: 'Saison',
  kicker: 'Rennen und Wochenplan',
  loadError: 'Die Saison lässt sich gerade nicht laden.',
  retry: 'Nochmal versuchen',
  loading: 'Lädt …',
  isoWeek: 'KW {n}',
  thisWeek: 'Diese Woche',
  runWalk: '{run} min laufen, {walk} min gehen · {list} min',

  head: {
    label: 'Überblick',
    nextRace: 'Nächstes Rennen',
    nextA: 'Hauptziel',
    phase: 'Gerade',
    none: 'Keins eingetragen',
    noneA: 'Kein A-Rennen eingetragen',
    noPhase: 'Noch kein Raster',
    draft: 'Entwurf',
    weekKm: 'Soll ~{km}',
    startsOn: 'Beginnt {date}',
  },
  count: {
    today: 'heute',
    tomorrow: 'morgen',
    days: { one: 'in {count} Tag', other: 'in {count} Tagen' },
    weeks: { one: 'in {count} Woche', other: 'in {count} Wochen' },
    past: 'vorbei',
  },
  empty: {
    title: 'Noch keine Rennen',
    text: 'Trag deine Rennen ein. Daraus entsteht ein Wochenraster bis zum letzten A- oder B-Rennen, das du erst bestätigst.',
    add: 'Rennen eintragen',
  },

  proposal: {
    titleFirst: 'Vorschlag für die Saison',
    title: 'Neuer Vorschlag',
    summaryFirst: { one: '{count} Woche, {from} bis {to}, Spitzenwoche im Training ~{km}.', other: '{count} Wochen, {from} bis {to}, Spitzenwoche im Training ~{km}.' },
    diffLabel: 'Unterschied je Woche',
    noDiff: 'An den Wochen ändert sich nichts.',
    showAll: 'Alle {count} zeigen',
    showLess: 'Weniger zeigen',
    apply: 'Übernehmen',
    applyFirst: 'Saison übernehmen',
    applying: 'Übernimmt …',
    dismiss: 'Ablehnen',
    note: 'Übernehmen schreibt Entwürfe für diese und die nächste Woche. Es landet nur als Entwurf in deiner Planung, nicht auf der Uhr.',
    applied: 'Übernommen. Die Entwürfe für zwei Wochen liegen in der Planung.',
    toPlanning: 'Zur Planung',
    dismissed: 'Abgelehnt. Das Raster bleibt, wie es ist.',
    dismissedFirst: 'Vorschlag abgelehnt. Er kommt wieder, sobald du ein Rennen oder die Einstellungen änderst.',
    weekLine: '{week}: {changes}',
    added: 'neu: {phase} ~{km}',
    removed: 'fällt weg',
    longRun: 'Long Run {from} → {to}',
    ride: 'Rad {from} → {to}',
    strength: 'Kraft {from}× pro Woche → {to}×',
    threshold: '{times} × {minutes} min Schwelle',
    qualityNow: 'jetzt {text}',
    qualityGone: 'keine {text} mehr',
    recoveryOn: 'jetzt Entlastung',
    recoveryOff: 'keine Entlastung mehr',
    runWalk: 'Lauf-Geh {text}',
    races: 'Rennen: {names}',
    noRaces: 'kein Rennen mehr',
    other: 'Einheiten angepasst',
  },

  chart: {
    title: 'Zeitstrahl',
    sub: 'Lauf-km je Woche',
    subDraft: 'Lauf-km je Woche, so sähe der Plan aus',
    aria: { one: 'Zeitstrahl über {count} Woche von {from} bis {to}, höchstens ~{km}.', other: 'Zeitstrahl über {count} Wochen von {from} bis {to}, höchstens ~{km}.' },
    ariaRaces: ' Rennen: {list}.',
    ariaTable: ' Alle Werte stehen auch in der Wochenliste.',
    plan: 'Soll',
    planDraft: 'Soll (Entwurf)',
    actual: 'Ist',
    actualSoFar: 'Ist (bisher)',
    recovery: 'Entlastung',
    /** Kurzzeichen über dem Balken; die Legende erklärt es. */
    recoveryMark: 'E',
    longRun: 'Long Run',
    ride: 'Rad',
    race: 'Rennen',
    inclRace: 'inkl. Rennen {km}',
    raceChips: 'A, B, C: Rennen, Namen in der Liste unten',
    phases: 'Phasen',
    explain: 'Was heißt das?',
    explainMobile: 'Legende und „Was heißt das?"',
    phaseShort: { wiedereinstieg: 'Einst', grundlage: 'Grund', aufbau: 'Aufb', spitze: 'Sp', huegel: 'Hüg', tapering: 'Tap', erholung: 'Erh' },
    showTable: 'Als Tabelle',
    tipRange: '{week} · {from}–{to}',
  },

  races: {
    title: 'Rennen',
    sub: 'A = Hauptziel · B = wichtig · C = Training',
    add: 'Rennen eintragen',
    past: 'Vergangen',
    edit: 'Rennen {name} bearbeiten',
    editShort: 'Bearbeiten',
    easy: 'locker',
    test: 'Test',
    goal: 'Ziel {time}',
    elevation: '{m}\u00a0Hm',
    priority: 'Priorität {p}',
  },
  form: {
    addTitle: 'Rennen eintragen',
    editTitle: 'Rennen bearbeiten',
    name: 'Name',
    namePlaceholder: 'z. B. Stadtlauf',
    date: 'Datum',
    distance: 'Distanz in km',
    distancePlaceholder: 'z. B. 21,1',
    elevation: 'Höhenmeter (optional)',
    elevationPlaceholder: 'z. B. 800',
    goal: 'Zielzeit (optional)',
    goalPlaceholder: 'h:mm:ss',
    goalHint: 'z. B. 2:07:00',
    goalRead: 'Gelesen als {time}',
    priority: 'Priorität',
    prioA: 'Hauptziel',
    prioB: 'Wichtig',
    prioC: 'Training',
    prioAHint: 'Volles Tapering und Erholung danach',
    prioBHint: 'Kurzes Tapering in der Rennwoche',
    prioCHint: 'Aus dem Training, ersetzt den Long Run',
    effort: 'Wie läufst du es?',
    effortEasy: 'Locker',
    effortEasyHint: 'Wie ein Long Run, im Plan in Z2',
    effortTest: 'Test',
    effortTestHint: 'Erst locker, die letzten 40 % im Renntempo',
    effortFull: 'Voll',
    effortFullHint: 'Im Renntempo, zählt als Prüfpunkt',
    saveNext: 'Speichern, noch ein Rennen',
    saved: 'Gespeichert: {name}',
    nameError: 'Name des Rennens fehlt',
    dateError: 'Datum fehlt',
    distanceError: 'Distanz in km eingeben, z. B. 21,1',
    elevationError: 'Höhenmeter als ganze Zahl eingeben',
    goalError: 'Zielzeit als h:mm:ss eingeben',
    deleteConfirm: 'Rennen „{name}" löschen?',
  },

  weeks: {
    title: 'Wochen',
    titleDraft: 'Wochen (Entwurf)',
    week: 'Woche',
    phase: 'Phase',
    soll: 'Soll',
    longRun: 'Long Run',
    ride: 'Rad',
    strength: 'Kraft',
    race: 'Rennen',
    actual: 'Ist',
    source: 'Soll aus dem Plan, Ist aus deinen Aktivitäten (aus Garmin, FIT und Strava-Export).',
    deltaNote: 'Δ zählt nur bis zur letzten vollen Woche.',
    under: 'zu wenig',
    over: 'zu viel',
    sums: 'Summen je Phase',
    sumTotal: 'Gesamt',
    sumWeeks: 'Wochen',
    bestWeek: '{km}, KW {n}/{year}',
    peakBest: 'Spitze {peak}: höchstens 110 % deiner besten Woche ({best}), das sind {limit}.',
    peakCap: 'Spitze {peak}: 110 % deiner besten Woche ({best}), begrenzt auf {limit} für {target}.',
    peakNone: 'Spitze {peak}. Noch keine Historie: Standardwert {limit} für diese Strecke.',
    peakLittle: 'Spitze {peak}. Zu wenig Historie (beste Woche {best}): Standardwert {limit} für diese Strecke.',
    peakNotReached: 'Mehr gibt die Steigerung von Woche zu Woche bis dahin nicht her.',
    open: '{week} in der Planung öffnen',
    showAll: 'Alle {count} zeigen',
    showLess: 'Ab dieser Woche zeigen',
    hills: '{m}\u00a0Hm',
    hillsDown: '{m}\u00a0Hm, davon die Hälfte bergab',
    longRide: 'Platz für eine lange Radtour',
    driftTest: 'Drift-Test statt Long Run ({min} min)',
    intervals: '4 × 4 min Intervalle',
    strengthCount: '{count}×',
    actualKm: 'Ist {km}',
    rideShort: 'Rad {text}',
    longShort: 'Long Run {text}',
    strengthShort: 'Kraft {count}×',
  },

  checkpoint: {
    title: 'Prüfpunkt',
    intro: '{race} am {date} zeigt, wo du vor {target} stehst.',
    lineFull: 'Prüfpunkt vor {target}: Richtzeit {time}, passend zu {goal} (Riegel-Formel).',
    lineNoGoal: 'Prüfpunkt vor {target}. Mit einer Zielzeit steht hier die Richtzeit.',
    waiting: 'Zu diesem Rennen ist noch kein Ergebnis da.',
    result: 'Ergebnis: {time} ({source})',
    official: 'offiziell',
    watch: 'Uhr',
    projected: 'Hochgerechnet auf {target} mit der Riegel-Formel: {time}. Das gilt nur, wenn du wirklich voll gelaufen bist.',
    slower: 'Die Zielzeit {goal} wirkt gerade nicht mehr realistisch, eher {suggested}. Geändert wird nichts, das geht nur am Rennen.',
    edit: 'Rennen bearbeiten',
  },

  settings: {
    title: 'Einstellungen',
    unsaved: 'Noch nichts gespeichert: Es gilt die Vorbelegung. Übernehmen speichert sie mit.',
    runs: 'Läufe pro Woche',
    runsHint: 'Im Wiedereinstieg immer 3, danach diese Zahl.',
    longDay: 'Long-Run-Tag',
    rideDay: 'Rad-Tag',
    rideMin: 'Rad-Dauer in min (0 = kein Rad)',
    strength: 'Kraft pro Woche',
    mobility: 'Mobility einplanen',
    intervals: '4×4-Intervalle im Aufbau',
    intervalsHint: 'Optional, standardmäßig aus. Eingeschaltet stehen die Einheiten fest im Aufbau: 4×4 min hart, sie ersetzen dort einen Teil der Schwelle.',
    strengthA: 'Kraft, Einheit A: Übungen',
    strengthB: 'Kraft, Einheit B: Übungen',
    strengthHint: 'Vorbelegung für Gewichte und eine Bank. Sätze, Sprünge und Steigerung legt der Plan fest, im Hügelblock kommen Step-ups bzw. Step-downs dazu; leer heißt Vorbelegung.',
    comebackWeeks: 'Wiedereinstieg in Wochen (0–6)',
    comebackFrom: 'Wiedereinstieg ab',
    rideHint: 'Lange Touren nur in Entlastungswochen, nicht am Vortag des Long Runs.',
    rideError: 'Rad-Dauer als ganze Zahl von 0 bis 480 eingeben',
    saved: 'Gespeichert. Ändert sich dadurch etwas, steht oben ein neuer Vorschlag.',
  },

  phaseHelp: {
    wiedereinstieg: 'Laufen und Gehen im Wechsel, nach Zeit. Der Körper gewöhnt sich wieder ans Laufen.',
    grundlage: 'Ruhige Kilometer: Der Umfang wächst, fast alles bleibt locker.',
    aufbau: 'Dazu eine schnellere Einheit pro Woche.',
    spitze: 'Die umfangreichsten Wochen vor dem Hauptziel, mit Abschnitten im Renntempo.',
    huegel: 'Stücke bergauf und ein Long Run mit Höhenmetern vor dem Bergrennen.',
    tapering: 'Kürzer treten vor dem Rennen, damit du frisch am Start stehst.',
    erholung: 'Nach dem Rennen wenig und nur locker, bis die Beine wieder wollen.',
    recovery: 'Jede vierte Woche und nach längeren Rennen etwas weniger, damit das Training wirken kann.',
    longRun: 'Dein längster Lauf der Woche.',
    sollIst: 'Soll ist der Plan, Ist das, was deine Aktivitäten zeigen.',
  },
  care: {
    painTitle: 'Es zwickt?',
    pain: 'Ersetze die Einheit durch Gehen oder Rad. Schmerz, der beim Laufen zunimmt oder bleibt: pausieren und abklären lassen. Die App stellt keine Diagnose.',
    missedTitle: 'Woche verpasst?',
    missed: 'Nichts nachholen. Der Plan schlägt die Anpassung selbst vor, du bestätigst sie.',
  },

  rules: {
    title: 'Nach welchen Regeln?',
    hint: 'Trainingsempfehlung, keine medizinische Beratung. Schmerzen gehen vor.',
  },
};
